import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {
  subjects as S,
  permissionTypes as T
} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import {deleteTask} from '../../actions/TasksTableActions';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

const PopupDeleteTask = ({id}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const dispatch = useDispatch();
  const intl = useIntl();
  const header = intl.formatMessage({
    id: 'tasks-page-popup-delete-task-header',
    defaultMessage: `Delete task ${id}`
  }, {id});

  const handleDelete = async (taskID) => {
    try {
      await dispatch(deleteTask(taskID));
    } catch (e) {
      console.error(e);
    }
    handleCloseModal();
  };

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        title={TTS.DELETE_TASK}
        onClick={handleShowModal}
        disabled={!can(T.FULL, S.TASKS_PAGE)}
        label={<img src={toAbsoluteUrl('media/common/Delete_red.svg')} alt="delete"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={header}/>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            label={intl.formatMessage({id: 'button-decline', defaultMessage: 'Decline'})}
            onClick={handleCloseModal}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            label={intl.formatMessage({id: 'button-delete', defaultMessage: 'Delete'})}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            onClick={() => handleDelete(id)}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupDeleteTask;
